export const AnalyticsEventActions = {
    START: 'start',
    REVIEW: 'review',
    CONFIRMATION: 'confirmation'
};
export const AnalyticsEventFeatures = {
    MAKE_A_PAYMENT: 'make_a_payment',
    ENROLL_AUTOPAY: 'enroll_autopay',
    MODIFY_AUTOPAY: 'modify_autopay',
    CANCEL_AUTOPAY: 'cancel_autopay',
    ADD_PAYMENT_METHOD: 'add_payment_method',
    MANAGE_PAYMENT_METHOD: 'manage_payment_method',
    DELETE_PAYMENT_METHOD: 'delete_payment_method'
};
export const AnalyticsPaymentMethods = {
    DEBIT: 'debit',
    CREDIT: 'credit',
    CHECKING: 'checking',
    SAVING: 'saving'
};
export const AnalyticsAccountStatuses = {
    CURRENT: 'current',
    DELINQUENT: 'delinquent',
    CAP_ENROLLED: 'capEnrolled',
    SETTLEMENT_ENROLLED: 'settlementEnrolled'
};
export const AutopayStatusEnum = {
    ENROLLED: 'enrolled',
    UNENROLLED: 'unenrolled'
};
